/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { serverInfoSelector } from 'src/app/store/app.selectors';
import { isEmpty } from 'lodash-es';
import { AppHttpService } from '@services/app-http.service';
import { ProductInfo } from '@foglight/angular-common';

@Injectable({
  providedIn: 'root',
})
export class AvailabilityGuard implements CanActivate {
  unavailableMessage;
  isCloud;
  constructor(
    private router: Router,
    private store: Store,
    private httpService: AppHttpService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(serverInfoSelector).pipe(
      switchMap((productInfo: ProductInfo) => {
        if (isEmpty(productInfo)) {
          return this.httpService.getProductInfo().pipe(
            map((productInfo) => {
              return this.verifyAvailability(productInfo, route);
            })
          );
        } else {
          return of(this.verifyAvailability(productInfo, route));
        }
      }),
      catchError((error) => of(false))
    );
  }

  verifyAvailability(productInfo: ProductInfo, route: ActivatedRouteSnapshot) {
    let isCloud = productInfo.isCloud;
    let canLoad = false;
    // users management availability
    if (route.url.toString().includes('manage-users')) {
      canLoad = isCloud;
      if (!canLoad) {
        this.unavailableMessage =
          'This page is not available for this deployment type';
        sessionStorage.setItem('lastErrorMessage', this.unavailableMessage);
        this.router.navigateByUrl('unavailable');
      }
    }

    if (route.url.toString().includes('home')) {
      canLoad = isCloud;
      if (!canLoad) {
        this.unavailableMessage =
          'This page is not available for this deployment type';
        sessionStorage.setItem('lastErrorMessage', this.unavailableMessage);
        this.router.navigateByUrl('unavailable');
      }
    }

    if (route.url.toString().includes('system-aui-administration')) {
      canLoad = isCloud;
      if (!canLoad) {
        this.unavailableMessage =
          'This page is not available for this deployment type';
        sessionStorage.setItem('lastErrorMessage', this.unavailableMessage);
        this.router.navigateByUrl('unavailable');
      }
    }

    return canLoad;
  }
}
